module.exports = __webpack_public_path__ + "static/media/shreyas_katkar.01ab53f7.png";